<template>

    <div class="position-absolute bg-white shadow-sm w-100 autocomplete-suggestions" :class="{visible: loaded}">

        <button 
            type="button" 
            class="btn-close position-absolute end-0 m-3" 
            aria-label="Close"
            @click="closeSuggestions"
            >
        </button>

        <div class="position-absolute autocomplete-suggestions__loading" v-if="loading"></div>

        <div class="p-3" v-if="loaded && totalResults === 0">
            {{ __('Keine Ergebnisse.') }}
        </div>
        <div class="list-group list-group-flush" v-else @keyup='nextItem'>

            <template v-if="results.suppliers.count">
                <div class="m-3 small text-uppercase text-primary fw-bold">
                    {{ __('Suppliers') }}
                    <!--{{ __('Lieferanten (:count)', {count: $options.filters.localizeNumber(results.suppliers.count)}) }}-->
                </div>
                <div class="list-group-item">
                    <div class="row row-cols-3 row-cols-lg-4 align-items-center justify-content-center g-3 g-lg-4">
                        <div
                            class="col"
                            v-for="(supplier, val, index) in results.suppliers.items"
                            >
                            <inertia-link
                                :href="supplier.permalink"
                                class="link-dark"
                                :class="{active: index === currentItem}"
                                :key="supplier.id"
                                >
                                <img 
                                    v-if="supplier.logo"
                                    class="img-fluid" 
                                    :src="supplier.logo" 
                                    :alt="supplier.short_name" 
                                    style="max-height: 40px;"
                                    />
                                <div v-else class="p-3 bg-light border text-center fw-bold small text-truncate rounded-3" :title="supplier.short_name">
                                    {{ supplier.short_name }}
                                </div>
                            </inertia-link>
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="results.products.count">
                <div class="m-3 small text-uppercase text-primary fw-bold">
                    {{ __('Produkte (:count)', {count: $options.filters.localizeNumber(results.products.count)}) }}
                </div>
                <inertia-link
                    :href="product.permalink" 
                    class="list-group-item list-group-item-action"
                    v-for="(product, val, index) in results.products.items"
                    :class="{active: index === currentItem}"
                    :key="product.id"
                    >
                    <div class="row align-items-center">
                        <div class="col-2">
                            <img :src="product.main_image_url" :alt="product.name" class="autocomplete-suggestions__image">
                        </div>
                        <div class="col-7">
                            <h6 class="mb-1 line-clamp-1">
                                {{ product.name }}
                            </h6>
                            <div class="small">
                                {{ __('Lieferanten-Artikelnr.') }}
                                <span class="text-black-50">
                                    {{ product.supplier_pid || '-' }}
                                </span>
                            </div>
                            <tax-info :product="product" />
                            <delivery-info :product="product" />
                        </div>
                        <div class="col-3 text-end text-nowrap">

                            <div class="fw-bold" v-if="product.default_price">
                                {{ product.default_price.price | localizeAmount }}
                            </div>
                            <div class="small text-secondary text-nowrap" v-if="product.price_quantity > 1">
                                {{ __('je :quantity Stck.', {quantity: product.price_quantity}) }}
                            </div>

                            <!--<price-info :product="product" />-->

                            <!--                            <template v-if="product.optimal_price">
                                                            <div class="fw-bold">
                                                                {{ __('ab :price', {price: $options.filters.localizeAmount(product.optimal_price.price)}) }}
                                                            </div>
                                                            <div class="text-black-50" v-if="product.optimal_price.lower_bound > 1">
                                                                {{ __('ab :lowerBound Stck.', {lowerBound: $options.filters.localizeNumber(product.optimal_price.lower_bound)}) }}
                                                            </div>
                                                        </template>-->

                        </div>
                    </div>
                </inertia-link>
            </template>

            <template v-if="results.categories.count">
                <div class="m-3 small text-uppercase text-primary fw-bold">
                    {{ __('Kategorien (:count)', {count: $options.filters.localizeNumber(results.categories.count)}) }}
                </div>
                <inertia-link
                    :href="category.permalink"
                    class="list-group-item list-group-item-action"
                    v-for="(category, val, index) in results.categories.items"
                    :class="{active: index === currentItem}"
                    :key="category.id"
                    >
                    <div class="row align-items-center">
                        <div class="col-2">
                            <img :src="category.image_url" :alt="category.name" class="autocomplete-suggestions__image">
                        </div>
                        <div class="col-10">
                            <div class="small text-muted" v-if="category.parent">
                                {{ category.parent.name }}
                            </div>
                            <h6 class="mb-1">
                                {{ category.name }}
                            </h6>
                        </div>
                    </div>
                </inertia-link>
            </template>

            <div class="">
                <inertia-link :href="route('search.index', {search: searchQuery})" class="btn btn-dark w-100">
                    {{ __('Alle Ergebnisse anzeigen') }}
                </inertia-link>
            </div>

        </div>



    </div>


</template>


<script>
    import PriceInfo from '@/shared/PriceInfo';
    import TaxInfo from '@/shared/TaxInfo';
    import DeliveryInfo from '@/shared/DeliveryInfo';

    import debounce from 'lodash/debounce'

    export default {
        props: [
            'searchQuery',
        ],
        data() {
            return {
                loaded: false,
                loading: false,
                totalResults: 0,
                results: {
                    products: {},
                    suppliers: {},
                    categories: {},
                },
                currentItem: 0,
            }
        },
        mounted() {
            document.addEventListener("keyup", this.nextItem);

            // @todo ggf auch results resetten?
            this.$inertia.on('start', (event) => {
                if (this.loaded || this.totalResults) {
                    console.log('Closing suggestions.');
                    this.loaded = false;
                    this.totalResults = 0;
                }
            })
        },
        components: {
            PriceInfo,
            TaxInfo,
            DeliveryInfo,
        },
        watch: {
            searchQuery: {
                handler: debounce(function () {

                    if (this.searchQuery === '') {
                        this.loaded = false;
                        return;
                    }

                    this.loading = true;
                    axios.get(this.route('search.autocomplete'), {params: {search: this.searchQuery}}).then((response) => {
                        this.results = response.data.data;
                        this.totalResults = response.data.total;
                        this.loaded = true;
                        this.loading = false;
                    })
                }, 200, {trailing: true})
            },
        },
        computed: {

        },
        methods: {
            nextItem() {
                // @todo bei enter product/category aufrufen
                if (event.keyCode == 38 && this.currentItem > 0) {
                    this.currentItem--;
                    console.log('prev item');
                } else if (event.keyCode == 40 && this.currentItem < this.totalResults) {
                    this.currentItem++;
                    console.log('next item');
                }
            },
            resetSuggestions() {
                this.results = [];
            },
            closeSuggestions() {
                console.log('Closing suggestions.');
                this.loaded = false;
                this.totalResults = 0;
            },
        }
    }
</script>